// extracted by mini-css-extract-plugin
export default {"root":"styles_root__4Veyd","label":"styles_label__A+rwy","selected":"styles_selected__0p-st"};